export default "__VITE_ASSET__DyeanHnT__"